import { Continue, Intro, PwaInfo, WelcomePageBgColor } from '../../../shared/constants/constants';
import React, { useEffect, useState } from 'react';
import { StoreInfoState, fetchStoreInfoDataAsync } from '../../../redux/reducers/storeInfoSlice';
import { getDeviceToken, saveStoreId } from '../../../services/token.service';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Button from '@albertsons/uds/molecule/Button';
import CarouselComponent from '../../../shared/carousel/components/carousel.component';
import LoginComponent from '../login/login.component';
import { RootState } from '../../../config/redux/store';
import { openAlertAsync } from '../../../redux/reducers/alertSlice';

const WelcomePageComponent: React.FC = () => {
  const [deviceToken, setDeviceToken] = useState<string | null>(null);
  const [showWelcome, setShowWelcome] = useState<boolean>(true);
  const [enableContinueBtn, setEnableContinueBtn] = useState<boolean>(false);

  const { storeInfo } = useSelector<RootState, StoreInfoState>((state) => state.globalVendorCheckIn.storeInfo);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const storeIdFromParams = searchParams.get('storeId') as string;

  const showLoginPage = () => {
    setShowWelcome(false);
  };

  useEffect(() => {
    if (deviceToken && storeIdFromParams) {
      navigate('/checkin-summary?storeId=' + storeIdFromParams);
    } else if (deviceToken) {
      navigate('/checkin-summary');
    }
  }, [deviceToken, navigate, storeIdFromParams]);

  useEffect(() => {
    getDeviceToken().then((token) => {
      setDeviceToken(token);
    });
  }, []);

  useEffect(() => {
    if (storeIdFromParams) {
      saveStoreId(storeIdFromParams);
    } else {
      const storeIdFromAPi = storeInfo?.stores?.length > 0 ? storeInfo?.stores[0]?.storeId : '';
      saveStoreId(storeIdFromAPi);
    }
  }, [storeIdFromParams, storeInfo?.stores]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          dispatch(fetchStoreInfoDataAsync({ lat: position.coords.latitude, lng: position.coords.longitude }));
          //for local testing
          // dispatch(fetchStoreInfoDataAsync({ lat: 43.64735256, lng: -116.3520867 }));
        },
        (error) => {
          if (storeIdFromParams) {
            dispatch(fetchStoreInfoDataAsync({ storeId: storeIdFromParams }));
          } else {
            dispatch(openAlertAsync('Please enable location services or provide a store ID to check in.'));
          }
        }
      );
    } else if (storeIdFromParams) {
      dispatch(fetchStoreInfoDataAsync({ storeId: storeIdFromParams }));
    } else {
      dispatch(openAlertAsync('Please enable location services or provide a store ID to check in.'));
    }
  }, [dispatch, storeIdFromParams]);

  useEffect(() => {
    const vendors = storeInfo?.stores?.length > 0 ? storeInfo?.stores[0]?.vendors : [];
    const purposes = storeInfo?.stores?.length > 0 ? storeInfo?.stores[0]?.purposes : [];
    if (vendors?.length > 0 && purposes?.length > 0) {
      setEnableContinueBtn(true);
    }
  }, [storeInfo?.stores]);

  /** Removing to get the current timezone
  useEffect(() => {
    Need to remove in future
     * if (storeInfo?.stores?.length > 0 && storeInfo?.stores[0]?.timezone) {
       saveXSwyTimeZone(storeInfo.stores[0].timezone);
     }
     }, [storeInfo?.stores]);

    saveXSwyTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  }, []);
     */

  return (
    <>
      {showWelcome ? (
        <div
          className='container mx-auto px-4 sm:px-6 lg:px-8'
          style={{
            backgroundColor: WelcomePageBgColor
          }}
        >
          <div className='flex justify-center items-center h-screen'>
            <div className='text-center'>
              <h1 className='text-xl text-white font-bold mb-4'>{Intro}</h1>
              <p className='text-lg text-white'>{PwaInfo}</p>
              <CarouselComponent></CarouselComponent>
              <div className='mt-4'></div>
              <Button variant='secondary' onClick={showLoginPage} disabled={!enableContinueBtn}>
                {Continue}
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <LoginComponent />
      )}
    </>
  );
};

export default WelcomePageComponent;
